import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import HeaderCustom from "../../../components/HeaderCustom";
import "../../../styles/AppCss.css";
import {
    getFiltrarLocalesGiftCard,
    getFiltrarUsuarios,
    postCrearCompra,
} from "../../../api/ApiService";

function AddCompraPage() {
    const [cargando, setCargando] = useState(false);
    const [loadingGuardar, setLoadingGuardar] = useState(false);
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState("");
    const [mensaje, setMensaje] = useState("");

    const [empresaQuery, setEmpresaQuery] = useState("");
    const [usuarioQuery, setUsuarioQuery] = useState("");
    const [empresas, setEmpresas] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [loadingEmpresas, setLoadingEmpresas] = useState(false);
    const [loadingUsuarios, setLoadingUsuarios] = useState(false);

    const [empresaSelected, setEmpresaSelected] = useState(null);
    const [usuarioSelected, setUsuarioSelected] = useState(null);
    const [fechaCompra, setFechaCompra] = useState("");
    const [montoCompra, setMontoCompra] = useState("");
    const [esGentileza, setEsGentileza] = useState(false);
    const [observacion, setObservacion] = useState("");
    const [numeroComprobante, setNumeroComprobante] = useState("");

    const stateToken = useSelector((state) => state.reducerGlobal.token);
    const navigate = useNavigate();

    const openAlert = (type, text) => {
        setSeverity(type);
        setMensaje(text);
        setOpen(true);
    };

    const handleFiltrarEmpresas = (term) => {
        const body = {
            nombre: term,
            page: "",
            per_page: "",
        };

        setLoadingEmpresas(true);

        getFiltrarLocalesGiftCard(stateToken?.access_token, body)
            .then((response) => {
                if (Array.isArray(response?.data) && response.data.length > 0) {
                    setEmpresas(response.data);
                } else {
                    setEmpresas([]);
                }
            })
            .catch(() => {
                setEmpresas([]);
            })
            .finally(() => {
                setLoadingEmpresas(false);
            });
    };

    const handleFiltrarUsuarios = (term) => {
        const body = {
            page: "",
            per_page: "",
            estado: "",
            term: term,
            email: "",
            verificacion: "",
            tipo: "",
            tester: "",
        };

        setLoadingUsuarios(true);

        getFiltrarUsuarios(stateToken?.access_token, body)
            .then((response) => {
                if (Array.isArray(response?.data) && response.data.length > 0) {
                    setUsuarios(response.data);
                } else {
                    setUsuarios([]);
                }
            })
            .catch(() => {
                setUsuarios([]);
            })
            .finally(() => {
                setLoadingUsuarios(false);
            });
    };

    useEffect(() => {
        if (!stateToken?.access_token) {
            return;
        }
        setCargando(true);
    }, [stateToken]);

    useEffect(() => {
        if (!stateToken?.access_token) {
            return;
        }

        const timeoutId = setTimeout(() => {
            if (empresaQuery.trim().length >= 2) {
                handleFiltrarEmpresas(empresaQuery.trim());
            } else {
                setEmpresas([]);
            }
        }, 500);

        return () => clearTimeout(timeoutId);
    }, [empresaQuery, stateToken]);

    useEffect(() => {
        if (!stateToken?.access_token) {
            return;
        }

        const timeoutId = setTimeout(() => {
            if (usuarioQuery.trim().length >= 2) {
                handleFiltrarUsuarios(usuarioQuery.trim());
            } else {
                setUsuarios([]);
            }
        }, 500);

        return () => clearTimeout(timeoutId);
    }, [usuarioQuery, stateToken]);

    const getEmpresaLabel = (option) => {
        // MUI requiere que siempre se retorne string en getOptionLabel.
        if (!option) return "";
        if (typeof option === "string") return option;
        const nombreEmpresa = option?.nombre_empresa || "";
        const emailEmpresa = option?.email_empresa || "";
        return [nombreEmpresa, emailEmpresa].filter(Boolean).join(" - ");
    };

    const getUsuarioLabel = (option) => {
        if (!option) return "";
        const firstName = option?.user?.first_name || option?.first_name || "";
        const lastName = option?.user?.last_name || option?.last_name || "";
        const nombre = `${firstName} ${lastName}`.trim();
        const ci = option?.ci || option?.cedula || option?.documento || "";
        return [nombre, ci].filter(Boolean).join(" - ");
    };

    const validateFields = () => {
        if (!empresaSelected?.id) {
            openAlert("warning", "Debes seleccionar una empresa.");
            return false;
        }
        if (!usuarioSelected?.id) {
            openAlert("warning", "Debes seleccionar un usuario.");
            return false;
        }
        if (!fechaCompra) {
            openAlert("warning", "El campo fecha de compra es obligatorio.");
            return false;
        }
        if (montoCompra === "" || Number(montoCompra) <= 0) {
            openAlert("warning", "El monto de compra debe ser mayor a 0.");
            return false;
        }
        if (numeroComprobante.trim() === "") {
            openAlert("warning", "El numero de comprobante es obligatorio.");
            return false;
        }
        return true;
    };

    const handleGuardar = () => {
        if (!validateFields()) {
            return;
        }

        const body = {
            empresa_id: Number(empresaSelected?.id),
            usuario_id: Number(usuarioSelected?.id),
            fecha_compra: fechaCompra,
            monto_compra: Number(montoCompra),
            es_gentileza: esGentileza ? 1 : 0,
            observacion: observacion,
            numero_comprobante: numeroComprobante.trim(),
        };

        // Objeto enviado a postCrearCompra:
        // {
        //   empresa_id,
        //   usuario_id,
        //   fecha_compra,
        //   monto_compra,
        //   es_gentileza,
        //   observacion,
        //   numero_comprobante
        // }
        // console.log("Body a enviar en postCrearCompra:", body);
        setLoadingGuardar(true);

        postCrearCompra(stateToken?.access_token, body)
            .then(() => {
                openAlert("success", "Compra creada con exito.");
                setTimeout(() => {
                    navigate("/app/admin/compras");
                }, 1500);
            })
            .catch(() => {
                openAlert("error", "Error al crear la compra.");
            })
            .finally(() => {
                setLoadingGuardar(false);
            });
    };

    const handleCancelar = () => {
        navigate(-1);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-4 sm:p-6">
                <div className="mx-auto max-w-5xl">
                    <div className="mb-6">
                        <h1 className="mb-1 text-2xl font-bold text-gray-800">Crear compra</h1>
                        <p className="text-sm text-gray-500">Selecciona empresa, usuario y completa los datos para registrar la compra.</p>
                    </div>

                    {cargando ? (
                        <div className="rounded-xl bg-white p-6 shadow-xl">
                            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                                <div>
                                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Empresa</label>
                                    <Autocomplete
                                        disablePortal
                                        options={empresas}
                                        fullWidth
                                        loading={loadingEmpresas}
                                        value={empresaSelected || null}
                                        getOptionLabel={getEmpresaLabel}
                                        renderOption={(props, option) => (
                                            <li {...props} key={option?.id}>
                                                <div className="flex flex-col">
                                                    <span className="text-sm text-gray-800 font-medium">
                                                        {option?.nombre_empresa || option?.email_empresa || "Sin nombre"}
                                                    </span>
                                                    <span className="text-xs text-gray-500">
                                                        {option?.direccion_empresa || "-"}
                                                    </span>
                                                </div>
                                            </li>
                                        )}
                                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                        onInputChange={(event, newInputValue, reason) => {
                                            if (reason === "input") {
                                                setEmpresaQuery(newInputValue);
                                            }
                                        }}
                                        onChange={(event, value) => {
                                            setEmpresaSelected(value);
                                        }}
                                        loadingText={"Cargando..."}
                                        noOptionsText={"No hay opciones"}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Seleccione empresa"
                                                size="small"
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        backgroundColor: "#f1f5f9",
                                                        borderRadius: "0.5rem",
                                                        fontSize: "0.875rem",
                                                    },
                                                }}
                                            />
                                        )}
                                    />
                                </div>

                                <div>
                                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Usuario</label>
                                    <Autocomplete
                                        disablePortal
                                        options={usuarios}
                                        fullWidth
                                        loading={loadingUsuarios}
                                        value={usuarioSelected || null}
                                        getOptionLabel={getUsuarioLabel}
                                        renderOption={(props, option) => (
                                            <li {...props} key={option?.id}>
                                                <div className="flex flex-col">
                                                    <span className="text-sm text-gray-800 font-medium">
                                                        {/* {option?.user?.last_name || option?.user?.first_name || "Sin nombre"} */}
                                                        {getUsuarioLabel(option)}
                                                    </span>
                                                    <span className="text-xs text-gray-500">
                                                        {option?.user?.email || "-"}
                                                    </span>
                                                </div>
                                            </li>
                                        )}
                                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                        onInputChange={(event, newInputValue, reason) => {
                                            if (reason === "input") {
                                                setUsuarioQuery(newInputValue);
                                            }
                                        }}
                                        onChange={(event, value) => {
                                            setUsuarioSelected(value);
                                        }}
                                        loadingText={"Cargando..."}
                                        noOptionsText={"No hay opciones"}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Seleccione usuario"
                                                size="small"
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        backgroundColor: "#f1f5f9",
                                                        borderRadius: "0.5rem",
                                                        fontSize: "0.875rem",
                                                    },
                                                }}
                                            />
                                        )}
                                    />
                                </div>

                                <div>
                                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Fecha de compra</label>
                                    <input
                                        type="date"
                                        value={fechaCompra}
                                        onChange={(e) => setFechaCompra(e.target.value)}
                                        className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2.5 text-sm outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                                    />
                                </div>

                                <div>
                                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Monto de compra</label>
                                    <input
                                        type="text"
                                        min="1"
                                        step="1"
                                        //formatear a moneda local PYG
                                        value={montoCompra ? Number(montoCompra).toLocaleString("es-PY") : ""}
                                        //permitir solo numeros y eliminar puntos o comas al escribir
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/[\.,]/g, "");
                                            if (/^\d*$/.test(value)) {
                                                setMontoCompra(value);
                                            }
                                        }}
                                        className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2.5 text-sm outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                                        placeholder="5000000"
                                    />
                                </div>

                                <div className="md:col-span-2">
                                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Numero de comprobante</label>
                                    <input
                                        type="text"
                                        value={numeroComprobante}
                                        onChange={(e) => setNumeroComprobante(e.target.value)}
                                        className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2.5 text-sm outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                                        placeholder="142536987"
                                    />
                                </div>

                                <div className="md:col-span-2">
                                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Observacion</label>
                                    <textarea
                                        value={observacion}
                                        onChange={(e) => setObservacion(e.target.value)}
                                        rows={4}
                                        className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2.5 text-sm outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                                        placeholder="observacion"
                                    />
                                </div>

                                <div className="md:col-span-2">
                                    <label className="inline-flex items-center gap-2 text-sm text-gray-700">
                                        <input
                                            type="checkbox"
                                            checked={esGentileza}
                                            onChange={(e) => setEsGentileza(e.target.checked)}
                                            className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                        />
                                        Es gentileza
                                    </label>
                                </div>
                            </div>

                            <div className="mt-6 flex flex-wrap items-center gap-4 border-t border-gray-200 pt-6">
                                <button
                                    type="button"
                                    onClick={handleGuardar}
                                    className="rounded-lg bg-[#104063] px-6 py-2 font-medium text-white transition-colors hover:bg-[#0d3553]"
                                >
                                    Guardar
                                </button>
                                <button
                                    type="button"
                                    onClick={handleCancelar}
                                    className="rounded-lg bg-gray-100 px-6 py-2 font-medium text-gray-700 transition-colors hover:bg-gray-200"
                                >
                                    Cancelar
                                </button>
                            </div>
                        </div>
                    ) : (
                        <div className="bg-white rounded-xl shadow-md p-8">
                            <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                            <div className="space-y-4">
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-24 bg-gray-200 rounded animate-pulse" />
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {loadingGuardar && (
                <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/35 backdrop-blur-sm">
                    <div className="flex items-center gap-3 rounded-xl bg-white px-5 py-4 shadow-xl">
                        <CircularProgress size={20} />
                        <p className="text-sm font-medium text-gray-700">Guardando compra...</p>
                    </div>
                </div>
            )}

            {open && (
                <div className="fixed right-4 top-4 z-[10000] max-w-sm">
                    <div
                        className={`rounded-xl border px-4 py-3 shadow-lg ${severity === "success"
                            ? "border-emerald-200 bg-emerald-50 text-emerald-700"
                            : severity === "warning"
                                ? "border-amber-200 bg-amber-50 text-amber-700"
                                : "border-red-200 bg-red-50 text-red-700"
                            }`}
                    >
                        <div className="flex items-start justify-between gap-4">
                            <p className="text-sm font-medium">{mensaje}</p>
                            <button
                                type="button"
                                onClick={handleClose}
                                className="text-current opacity-70 transition-opacity hover:opacity-100"
                            >
                                x
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </HeaderCustom>
    );
}

export default AddCompraPage;
